module.exports = __webpack_public_path__ + "img/900900425.fa817a12.png";